import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PageWithTable, TableWithSearch } from '../../ui/pageWithTable';
import { ContractsTabKeys, ContractGroup, getContractsPageUrl } from './helper';
import { useContractsActions } from './useContractsActions';

export interface ContractsPageProps {
  tab: string;
}

export const ContractsPage: FC<ContractsPageProps> = ({ tab }) => {
  const { t } = useTranslation();

  return (
    <PageWithTable
      title={t('contractsPage.contracts')}
      disclaimer={t('contractsPage.infoMessage')}
      tabs={[
        {
          label: t('contractsPage.layout.activeContracts'),
          url: getContractsPageUrl(ContractsTabKeys.Active),
          key: ContractsTabKeys.Active,
          component: (
            <TableWithSearch
              showSearch
              type={ContractGroup.ACTIVE}
              useFormActions={useContractsActions}
            />
          ),
        },
        {
          label: t('contractsPage.layout.concludedContracts'),
          url: getContractsPageUrl(ContractsTabKeys.Concluded),
          key: ContractsTabKeys.Concluded,
          component: (
            <TableWithSearch
              showSearch
              type={ContractGroup.INACTIVE}
              useFormActions={useContractsActions}
            />
          ),
        },
      ]}
      activeTab={tab}
    />
  );
};
